// ------------------------------------
// props 輸入需求 : 
// props.hide : function( void )                    ( 開關按鈕 )
// props.data : object : { data: array }            (  )
// ------------------------------------

import React, { useState, useEffect, useContext } from 'react'
import { useTranslation } from 'react-i18next';
import AddResident from './AddResident';
import AddPads from './AddPad';
import './_add.scss'
import AddUsers from './AddUser';
import { useSelector } from 'react-redux';
import { CTXHide } from '../Layout';
import { AddNavBar } from './AddNavBar';

const AddPageFrame =(props)=>{
    const { t } = useTranslation()
    const [page, setPage] = useState(null);
    const ctx_hide = useContext(CTXHide)
    const curAddPage = useSelector(state=>state.store_layout.currAddPage)
    // useEffect(()=>{dispatch(SET_PAGE(curLayoutPage))}, [curLayoutPage])
    useEffect(() => {
        if(curAddPage===1){ setPage(<AddResident />) }
        else if(curAddPage===2){ setPage(<AddPads />) }
        else if(curAddPage===3){ setPage(<AddUsers />) } 
    }, [curAddPage]);

    return(
        <div className="pos-f z-1 wid-full hig-full top-0 left-0 fx-ccc bg-black" onClick={ctx_hide}>
            <div className="layout-history fx-d-c pad-30 l r" onClick={e=>e.stopPropagation()}>
                <AddNavBar />
                <div className="h-85 fx-d-c w-100">
                    {page}  
                </div>
            </div>
        </div>
    );	

}
export default AddPageFrame;